export const API_URL = process.env.REACT_APP_API_URL as string;

/** システム名。Header.tsxとpublic/index.htmlの<title>と同じ表記にする */
export const APP_NAME = 'スマート検査報告書作成システム ST';
